import { useState, type FormEvent, type JSX } from 'react';

interface Lastnosti {
  /** Kaj mora uporabnik vpisati, da se brisanje izvede. */
  potrditev: string;
  /** Kaj piše nad vnosnim poljem. */
  navodilo: string;
  naIzbris: (potrditev: string) => Promise<void>;
}

/**
 * Trajno brisanje z vpisom potrditve.
 *
 * Vpis naziva oziroma e-naslova ni formalnost: brisanje iz arhiva odnese
 * podatke, ki jih ni mogoče dobiti nazaj.
 */
export function PotrdiIzbris({ potrditev, navodilo, naIzbris }: Lastnosti): JSX.Element {
  const [odprto, setOdprto] = useState(false);
  const [vpis, setVpis] = useState('');
  const [tece, setTece] = useState(false);
  const [napaka, setNapaka] = useState<string | null>(null);

  const oddaj = (dogodek: FormEvent): void => {
    dogodek.preventDefault();
    setTece(true);
    setNapaka(null);
    naIzbris(vpis)
      .catch((e: unknown) => {
        setNapaka(e instanceof Error ? e.message : 'Brisanje ni uspelo.');
      })
      .finally(() => {
        setTece(false);
      });
  };

  if (!odprto) {
    return (
      <button
        type="button"
        className="povezava nevarna"
        onClick={() => {
          setOdprto(true);
        }}
      >
        Trajno izbriši …
      </button>
    );
  }

  return (
    <form onSubmit={oddaj} className="obrazec potrditev">
      <label>
        {navodilo}
        <input
          value={vpis}
          onChange={(d) => {
            setVpis(d.target.value);
          }}
          autoFocus
          required
        />
      </label>
      {napaka !== null && <p className="napaka">{napaka}</p>}
      <div className="gumbi">
        <button type="submit" className="gumb" disabled={tece || vpis.trim() !== potrditev}>
          {tece ? 'Brišem …' : 'Dokončno izbriši'}
        </button>
        <button
          type="button"
          className="povezava"
          onClick={() => {
            setOdprto(false);
            setVpis('');
            setNapaka(null);
          }}
        >
          Prekliči
        </button>
      </div>
    </form>
  );
}
